export default __webpack_public_path__ + "static/media/clock.b8b8465b.svg";